<template>
    <my-form 
    v-model="form" 
    table 
    label-width="180px"
    @cancle="cancleHandler" 
    @submit="submitHandler"
    >

        <el-form-item 
        label="增资税普通发票类别" 
        prop="shyj" 
        class="table-full-row" 
        >
            <my-select v-model="form.by4" :data="invoiceTypes"></my-select>
        </el-form-item>

    </my-form>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'

export default {
    mixins: [ FORM_PAGE_MIXIN ],
    props: {
        orderscode: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            form: {
                by4: '',
            },

            invoiceTypes: [
                {
                    key: '1',
                    value: '电子增值税普通发票',
                },
                {
                    key: '2',
                    value: '纸质增值税普通发票',
                },
                {
                    key: '3',
                    value: '电子与纸质并行',
                },
            ]
        }
    },
    methods: {
        submitHandler() {
            this.$post(`${this.getGetters('mngUrl')}/manage/finance/auditorder/setfp.json`, this.form, (data, res) => {
                ShowMsg('设置成功', 'success');
                this.cancleHandler();
            });
        },
        cancleHandler() {
            this.$emit('cancle');
        }
    },
    created() {
        this.jspInit(`${this.getGetters('mngUrl')}/manage/finance/auditorder/setfptype.json`, {
            
        }, data => {
            this.form.by4 = data.fptype;
        });
    },
}
</script>

<style lang="scss" scoped>

</style>